import React, { useState, useEffect } from 'react';
import { Card as AntdCard, Descriptions } from 'antd';
import { useTranslation } from 'react-i18next'; // 导入 useTranslation
const StatsDisplay = ({ dataSource, projectTech }) => {
    const { t } = useTranslation(); // 调用 useTranslation Hook
    const [ddTotal, setDdTotal] = useState('0.00');
    const [treCount, setTreCount] = useState('0');
    const [hybridCount, setHybridCount] = useState('0');
    const [acroCount, setAcroCount] = useState('0');
    useEffect(() => {
        let currentDdTotal = 0;
        let currentTreCount = 0;
        let currentHybridCount = 0;
        let currentAcroCount = 0;
        dataSource.forEach(row => {
            const declaredDifficulty = parseFloat(row.declaredDifficulty || '0');
            const difficultyValue = parseFloat(row.difficultyValue || '0');
            const bonus = parseFloat(row.bonus || '0');
            currentDdTotal += difficultyValue || 0;
            //根据项目来统计计数
            const projectTech = (row.part || '').toUpperCase();
            if (projectTech === 'TRE')
                currentTreCount++;
            else if (projectTech === 'HYBRID')
                currentHybridCount++;
            else if (projectTech === 'ACRO')
                currentAcroCount++;
        });
        setDdTotal(currentDdTotal.toFixed(4));
        setTreCount(currentTreCount.toString());
        setHybridCount(currentHybridCount.toString());
        setAcroCount(currentAcroCount.toString());
    }, [dataSource]);
    return (<div style={{ padding: '10px 20px', marginTop: 20 }}>
      <AntdCard title={t('stats_display.coach_card_data_statistics')} size="small" bordered={false} style={{ marginBottom: 0 }}>
        <Descriptions column={4} size="small">
          <Descriptions.Item label={t('stats_display.total_difficulty')} style={{ fontWeight: 'bold' }}><span style={{ backgroundColor: '#ffff99' }}>{ddTotal}</span></Descriptions.Item>
          <Descriptions.Item label={t('stats_display.tre_count')} style={{ fontWeight: 'bold' }}>{treCount}</Descriptions.Item>
          <Descriptions.Item label={t('stats_display.hybrid_count')} style={{ fontWeight: 'bold' }}>{hybridCount}</Descriptions.Item>
          <Descriptions.Item label={t('stats_display.acro_count')} style={{ fontWeight: 'bold' }}>{acroCount}</Descriptions.Item>
        </Descriptions>
      </AntdCard>
    </div>);
};
export default StatsDisplay;
